import { theme } from './theme/theme-variables';

const config = { theme };

export default config;
